import React from "react"
import PropTypes from "prop-types"
import ClassNames from "classnames"
import Moment from "moment"
import DefaultStyles from "react-widgets/lib/less/react-widgets.less"
import DateTimePicker from "react-widgets/lib/DateTimePicker"
import createReactClass from "create-react-class"
import momentLocalizer from "react-widgets-moment"

import Styles from "../datepicker.less"
import ValidationMixin from "@cirrus/legacy/app-components/validations/validation-mixin/index.jsx"
import BaseStyles from "@cirrus/legacy/app-components/datetime/datepicker.less"

momentLocalizer()
var defaultValue = null
var DatePicker = createReactClass({
  propTypes: {
    value: PropTypes.any,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    tabIndex: PropTypes.number,
    autoFocus: PropTypes.bool,
    placeholder: PropTypes.string,
    format: PropTypes.string,
    onChange: PropTypes.func,
    editFormat: PropTypes.string,
    min: PropTypes.any,
    max: PropTypes.any,
    isNotValid: PropTypes.bool,
    "data-qa": PropTypes.string,
  },
  getDefaultProps: function () {
    var defaultFormat = Moment.localeData("en-GB")._longDateFormat.L
    return {
      format: defaultFormat,
      editFormat: defaultFormat,
    }
  },
  handleChange(e) {
    if (typeof this.props.onChange == "function") {
      this.props.onChange(e, e.target.value)
    }
  },
  getDefaultValue() {
    return defaultValue ? defaultValue : this.props.value
  },
  getClass() {
    return ClassNames(
      Styles.datePicker,
      {
        disabled: this.props.disabled,
      },
      this.props.className,
    )
  },
  render() {
    return (
      <DateTimePicker
        value={this.props.value}
        className={this.getClass()}
        defaultValue={this.getDefaultValue()}
        disabled={this.props.disabled}
        time={false}
        placeholder={this.props.placeholder}
        tabIndex={this.props.tabIndex}
        autoFocus={this.props.autoFocus}
        onChange={this.props.onChange}
        format={this.props.format}
        editFormat={this.props.editFormat}
        min={this.props.min}
        max={this.props.max}
        data-qa={this.props["data-qa"]}
      />
    )
  },
})

export default ValidationMixin(DatePicker)
